import type { IconData } from '@stacksjs/iconify-core'

export const hotelFiveStar: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M20.74 4.707a3.085 3.085 0 0 1 5.52 0l5.124 9.818L41.94 16.59c2.437.477 3.404 3.562 1.706 5.44l-7.388 8.165l1.381 11.12c.318 2.563-2.222 4.474-4.466 3.361L23.5 39.879l-9.672 4.797c-2.244 1.113-4.784-.798-4.466-3.36l1.381-11.122l-7.388-8.165c-1.698-1.877-.73-4.962 1.706-5.44l10.555-2.064z\"/><path d=\"M27.75 20h-7.583L19 27l.855-.428a7 7 0 0 1 3.13-.739h1.848a3.5 3.5 0 0 1 3.5 3.5V30.5a3.5 3.5 0 0 1-3.5 3.5H22.5a3.5 3.5 0 0 1-3.3-2.333\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default hotelFiveStar
